/**
 * StepVisuals — tiny CSS mock-ups so "How it works" shows the product instead of describing it.
 */
import { Check, Link as LinkIcon, Mic, Play, Sparkles } from "lucide-react";

const Frame = ({ children, testId }) => (
  <div className="rounded-xl bg-black/40 ring-1 ring-white/10 p-3 h-[132px] overflow-hidden relative" data-testid={testId}>{children}</div>
);

export const PasteLinkVisual = () => (
  <Frame testId="step-visual-link">
    <div className="rounded-lg bg-white/[0.06] ring-1 ring-violet-400/30 px-2.5 py-2 flex items-center gap-2">
      <LinkIcon className="w-3 h-3 text-violet-300 shrink-0" />
      <span className="text-[10px] text-white/85 font-mono truncate">yourstore.com/products/glow-serum</span>
      <span className="ml-auto w-1.5 h-3 bg-violet-300 animate-pulse rounded-sm" />
    </div>
    <div className="mt-2.5 flex items-center gap-2 rounded-lg bg-violet-500/10 ring-1 ring-violet-400/20 p-2">
      <div className="w-9 h-9 rounded-md bg-gradient-to-br from-violet-400/60 to-fuchsia-500/60" />
      <div className="flex-1 min-w-0">
        <p className="text-[10px] text-white font-bold truncate">Glow Renewal Serum · 30ml</p>
        <p className="text-[9px] text-white/70">$48 · 6 photos pulled · ready</p>
      </div>
      <Check className="w-3.5 h-3.5 text-violet-300" />
    </div>
  </Frame>
);

export const ScriptVisual = () => (
  <Frame testId="step-visual-script">
    <p className="text-[9px] uppercase tracking-wider text-violet-300 font-bold mb-1.5 flex items-center gap-1"><Sparkles className="w-3 h-3" /> Claude writes · compliance-checked</p>
    {["Hook — 'POV: your skin after 7 nights'", "Reveal — serum on a Bondi bathroom shelf", "Benefit — 'no filters, just glow'", "CTA — 'Try it free, link below'"].map((l, i) => (
      <div key={l} className="flex items-center gap-1.5 py-[3px]">
        <span className="w-3.5 h-3.5 rounded-full bg-violet-500/30 text-[8px] text-white flex items-center justify-center font-bold">{i + 1}</span>
        <span className="text-[10px] text-white/85 truncate">{l}</span>
      </div>
    ))}
  </Frame>
);

export const RenderVisual = () => (
  <Frame testId="step-visual-render">
    <div className="grid grid-cols-4 gap-1.5 h-full">
      {["from-fuchsia-500/70 to-violet-700/70", "from-violet-400/70 to-indigo-700/70", "from-indigo-400/70 to-violet-800/70", "from-violet-600/70 to-fuchsia-700/70"].map((g, i) => (
        <div key={g} className={`relative rounded-md bg-gradient-to-b ${g} ring-1 ring-white/10 overflow-hidden`}>
          <span className="absolute bottom-1 left-1 right-1 text-[7px] leading-tight text-white font-bold bg-black/50 rounded px-1 py-0.5 truncate">{["POV…", "Reveal", "Glow", "Try free"][i]}</span>
          {i === 0 && <Play className="w-3.5 h-3.5 text-white absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />}
        </div>
      ))}
    </div>
    <span className="absolute top-2 right-2 inline-flex items-center gap-1 rounded-full bg-black/60 px-1.5 py-0.5 text-[8px] text-white font-bold"><Mic className="w-2.5 h-2.5" /> voiceover</span>
  </Frame>
);

export const ScoreVisual = () => (
  <Frame testId="step-visual-score">
    <div className="flex items-center gap-3">
      <div className="w-14 h-14 rounded-full bg-gradient-to-br from-violet-500 to-indigo-600 flex items-center justify-center shadow-lg shadow-violet-500/30">
        <span className="text-white font-extrabold text-lg">87</span>
      </div>
      <div className="flex-1 space-y-1.5">
        {[["Hook", 92], ["CTA", 84], ["Psychology", 88], ["Conversion", 81]].map(([k, v]) => (
          <div key={k} className="flex items-center gap-1.5">
            <span className="text-[9px] text-white/80 w-14">{k}</span>
            <div className="flex-1 h-1.5 rounded-full bg-white/10 overflow-hidden"><div className="h-full rounded-full bg-gradient-to-r from-violet-400 to-fuchsia-400" style={{ width: `${v}%` }} /></div>
            <span className="text-[9px] text-white font-bold w-5 text-right">{v}</span>
          </div>
        ))}
      </div>
    </div>
    <p className="mt-2 text-[9px] text-white/80 text-center">Ship the winner · 1-tap export to Meta &amp; TikTok</p>
  </Frame>
);
